<ng-container *ngIf="this.shareOption === 'edit' && userValidation$ | async as userValidation">
  <ng-container  *ngIf="isOnActiveRoute('editor')">
    <button matTooltip="Hilfe" [matTooltipShowDelay]="300" mat-icon-button class="menu_icon"
            (click)="overlayOpen = !overlayOpen" cdkOverlayOrigin
            #trigger="cdkOverlayOrigin">
      <mat-icon class="icon-display" data-tour="step9">help_outline</mat-icon>
    </button>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="overlayOpen"
      [cdkConnectedOverlayFlexibleDimensions]="true"
      [cdkConnectedOverlayLockPosition]="true"
      [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
      [cdkConnectedOverlayViewportMargin]="5"

      (backdropClick)="overlayOpen = false"
      (detach)="overlayOpen=false"
    >
      <div class="scrollableGroup">
        <table class="helpOverlay" cdkScrollable>

          <th></th>
          <th>KI-Methoden für Elemente</th>
          <th>KI-Methoden für Misfits</th>

          <tr>
            <td class="symbolCell">
              <mat-icon class="material-symbols-outlined featureSymbol">cell_merge</mat-icon>
            </td>
            <td><b>Element-Verdichtung:</b> Zeigt, welche Verbindungen die KI zwischen den selektierten Elementen empfiehlt
            </td>
            <td><b>Misfit-Lösung:</b> Zeigt, welche Elemente die KI für die selektierten Misfits als Lösung empfiehlt.
            </td>
          </tr>
          <tr>
            <td>
              <mat-icon class="featureSymbol material-symbols-outlined">open_with</mat-icon>
            </td>
            <td><b>Element-Erweiterung:</b> Zeigt, welche Verbindungen die KI zu neuen, noch unselektierten Elementen
              empfiehlt.
            </td>
            <td><b>Misfit-Erweiterung:</b> Zeigt, auf welche Misfits die KI ausgehend von den selektierten Elementen hinweist.
            </td>
          </tr>
          <tr>
            <td>
              <mat-icon class="featureSymbol">sort</mat-icon>
            </td>
            <td><b>Sortierung:</b> Sortiert die manuell selektierten bzw. die von der KI empfohlenen Elementkarten.
            </td>
            <td><b>Sortierung:</b> Sortiert die manuell selektierten bzw. die von der KI empfohlenen Misfitkarten.</td>
          </tr>
          <tr>
            <td>
              <img class="controlLoopIcon" src="../../../assets/files/regelkreis_blau.png" alt="image" width="40px" height="40px">
            </td>
            <td><b>Regelkreisphasen:</b> Gruppiert die Elementkarten nach den vier Regelkreisphasen (Auftrag, Aktion,
              Welt, Reaktion).
            </td>
            <td rowspan="3">
              <div class='box yellow'></div>
              <div>
                <b>&nbsp;Erweiterung:&nbsp;</b>KI-empfohlene Verbindungen zu neuen Elementen.
              </div>
              <div class='box green'></div>
              <div>
                <b>&nbsp;Verdichtung:&nbsp;</b>KI-empfohlene Verbindungen zu vorhandenen Elementen.
              </div>
              <div class='box blue'></div>
              <div>
                <b>&nbsp;Selektion:&nbsp;</b>Manuell selektierte Elemente bzw. Verbindungen.
              </div>
              <div class='box red'></div>
              <div>
                <b>&nbsp;Auflösung:&nbsp;</b>Manuell selektierte Misfit-Auflösung durch ein Element.
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <mat-icon class="featureSymbol">question_mark</mat-icon>
            </td>
            <td><b>Leitfragen:</b> Gruppiert die Elementkarten danach, auf welche Frage sie eine Antwort geben.</td>
          </tr>
          <tr>
            <td colspan="2">
              <button class="downloadButton" mat-fab extended (click)="downloadAsset('WebApp_und_KI_Assistenz.pdf');">
                <mat-icon class="icon-display">download</mat-icon>
                Download: Ausführliche Anleitung
              </button>
            </td>
          </tr>

        </table>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
